import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { debounce } from 'lodash';
import { message } from 'antd';
import RichTextEditor from 'react-rte';

import { RestURL } from '../../config/properties';

export default function BannerHOC(BannerPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
      }).isRequired,
    };
    static initialState = {
      bannerText: RichTextEditor.createEmptyValue(),
    };

    state = WrappedComponent.initialState;

    async componentWillMount() {
      console.log(RestURL);
      try {
        const res = await Axios.get(`${RestURL}rest/api/banner`);
        let text = res.data;
        if (!text.replace(/\s/g, '').length) {
          text = RichTextEditor.createEmptyValue();
        }
        this.setState({
          bannerText: RichTextEditor.createValueFromString(text, 'html'),
        });
      } catch (error) {
        console.error(error);
      }

    }

    handleChange = value => {
      this.setState({
        bannerText: value,
      });
    };
    uploadBanner = debounce(async () => {
      // turns out to use the debounce the context that is being called is the banner and not the HOC so in order to get the jwt token I need auth to be on the context of banner ¯\_(ツ)_/¯
      console.log(this.props);
      try {
        await Axios.post(
          `${RestURL}rest/api/banner`,
          {
            bannerText: this.state.bannerText.toString('html'),
          },
          {
            headers: { Authorization: `Bearer ${this.props.auth.jwtToken}` },
          },
        );
        message.success('Banner Updated');
      } catch (error) {
        message.error('Try again in a few minutes');
      }
    }, 100);

    render() {
      const { bannerText } = this.state;
      const { auth } = this.props;
      // Configure Page
      const pageProps = {
        auth,
        bannerText,
        uploadBanner: this.uploadBanner,
        handleChange: this.handleChange,
      };

      return <BannerPage {...pageProps} />;
    }
  }

  return WrappedComponent;
}



// WEBPACK FOOTER //
// ./src/pages/Banner/BannerHOC.jsx